"use strict";

exports.__esModule = true;
var _AlertSubscription = require("./AlertSubscription");
Object.keys(_AlertSubscription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AlertSubscription[key]) return;
  exports[key] = _AlertSubscription[key];
});